import { Checkbox, FormControlLabel } from '@mui/material'

const CheckBoxCustom = ({
	label,
	labelColor,
	onChange,
	checked,
	lineColor,
	size = '18px',
	sx: customSx = {},
	...rest
}) => {
	return (
		<FormControlLabel
			key={`${label}-${checked}`}
			control={
				<Checkbox
					size="small"
					checked={checked}
					onChange={onChange}
					sx={{
						color: lineColor || '#DFE4EB',
						padding: label && '4px',
						width: size,
						height: size,
						borderRadius: '50%',

						'& .MuiSvgIcon-root': {
							borderRadius: '50%',
							width: size,
							height: size,
						},
						'&.MuiButtonBase-root': {
							marginRight: label && '8px',
							marginTop: label && '3px',
						},

						'&.Mui-checked': {
							color: '#7CA6BD',
						},
						...customSx,
					}}
				/>
			}
			label={label}
			{...rest}
			sx={{
				'&.MuiFormControlLabel-root': {
					margin: '0 !important',
					alignItems: 'start',
				},
				'& .MuiFormControlLabel-label': {
					fontSize: '14px',
					fontWeight: '400',
					color: labelColor ?? '#313131',
				},
				...customSx,

			}}
		/>
	)
}

export default CheckBoxCustom
